export enum ProductTypeName {
  hotel = 'hotel',
  winery = 'winery',
  tour = 'tour',
  event = 'event',
}

export enum ProductTypeId {
  hotel = 1,
  winery = 2,
  tour = 3,
  event = 4,
}
